import RecorderControls from "components/AudioRecorder/components/recorder-controls";
import RecordingItem from "components/AudioRecorder/components/recordings-list/RecordingItem";
import { Audio } from "components/AudioRecorder/types/recorder";
import { RecordingMic } from "containers/InterviewMeContainer/ChatAudio";
import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { Microphone, MicrophoneAltSlash } from "@styled-icons/fa-solid";
import { useMessagePopup } from "context/messagePopup";
import { StyledButton } from "containers/QuestionCodingPane/Coding/AnswerCTA";

const StyledChatContainer = styled.div`
    display: flex;
    gap: 1rem;
    align-items: center;

    .recording-container {
        max-width: 40rem;
        margin: auto;
    }
`;

const AnswerRecorder = (props: {
    recordedAudioStream: Audio | undefined;
    setRecordedAudioStream: (audio: undefined | Audio) => void;
    onSaveRecording: (audio: any, isVideo: boolean, transcribe?: string) => void;
    onClickRespond: () => void;
    disableSubmitResponse: boolean;
    showSubmitButton?: boolean;
    ctaLabel?: string;
}) => {

    const message = useMessagePopup();
    const [recording, setRecording] = useState<boolean>(false);

    const recordingControlRef = useRef<{
        startRecording: () => void;
        stopRecording: () => void;
    }>();

    const handleStartRecording = () => {
        if (recordingControlRef.current) {
            recordingControlRef.current.startRecording();
            props.setRecordedAudioStream(undefined);
            setRecording(true);
        }
    }

    const handleStopRecording = () => {
        if (recordingControlRef.current) {
            recordingControlRef.current.stopRecording();
            setRecording(false);
        }
    }

    const toggleRecording = () => {
        if (recording) {
            handleStopRecording();
        } else {
            if (props.recordedAudioStream) {
                message.confirm("Your previous recorded answer will be lost. Do you want to continue?",
                    () => {
                        handleStartRecording();
                    }
                );
            } else {
                handleStartRecording();
            }
        }
    }

    const handleSubmitResponse = () => {
        if (recording) {
            handleStopRecording();
        }
        setTimeout(() => {
            props.onClickRespond();
        }, 0)
    }

    return (
        <div className='d-flex align-items-center justify-content-between w-100'>
            <div className="flex-grow-1">
                <StyledChatContainer>
                    <div className="px-2">
                        <RecordingMic
                            disabled={false}
                            className="start-button p-0 d-flex align-items-center justify-content-center"
                            title="Speak Answer"
                            onClick={toggleRecording}
                            isRecognizing={recording}
                        >
                            {recording ? <MicrophoneAltSlash height={'1rem'} /> : <Microphone height={'1rem'} />}
                        </RecordingMic>
                    </div>
                    <div className="flex-grow-1 px-2 recording-container">
                        {props.recordedAudioStream && !recording && <RecordingItem
                            key={props.recordedAudioStream.key}
                            isReadOnly={true}
                            recordKey={props.recordedAudioStream.key!}
                            isDeleted={false}
                            audio={props.recordedAudioStream.audio}
                            onDelete={() => { }}
                            undoDelete={() => { }}
                        />}
                        {!props.recordedAudioStream && !recording && <span className="text-muted">Please record your answer</span>}
                        <div className={recording ? "" : "d-none"}>
                            <RecorderControls
                                onSaveRecording={props.onSaveRecording}
                                allowVoiceRecorder={true}
                                hideVideoRecorder={true}
                                compactView={true}
                                generateTranscribe={true}
                                hideActions
                                ref={recordingControlRef}
                            />
                        </div>
                    </div>
                </StyledChatContainer>
            </div>
            {props.showSubmitButton !== false && (
                <div className='d-flex align-items-center flex-column justify-content-center'>
                    <StyledButton
                        disabled={props.disableSubmitResponse}
                        size='small'
                        variant='contained'
                        color='primary'
                        className='m-1 mb-0'
                        width="9rem"
                        onClick={handleSubmitResponse}
                        title={'Submit Answer'}
                    >
                        {props.ctaLabel ? props.ctaLabel : 'Submit Answer'}
                    </StyledButton>
                </div>
            )}
        </div>
    )
}

export default AnswerRecorder;